import React from "react";
import { Controller } from "react-hook-form";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

export const Settings = ({
  isAdmin,
  watchedValues: { isMultiOrg, canAssignRole, isCorporate, isCorporateReporting },
  canChangeRole,
  control,
  organizations,
  linkUsersToSharePermissions,
  orgRoles
}) => {
  return (
    <>
      <div className="admin-users__info">
        <div className="admin-users__section">
          <div className="switch">
            <p className="switch__title">Multi Organizations</p>
            <Controller
              control={control}
              name="multi_organizations"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="multi_organizations"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>

          {isMultiOrg && (
            <div className="admin-users__dropdown">
              <p>Organizations</p>
              <Controller
                control={control}
                name="organization_ids"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      includeSelectAll
                      enableOnly
                      height={275}
                      haveOnSelectChange
                      options={organizations}
                      selectedFilters={value}
                      numberDisplayed={0}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
          )}

          {!isMultiOrg && !isAdmin && (
            <div className="admin-users__dropdown">
              <p>Organization</p>
              <Controller
                control={control}
                name="organization_id"
                render={({ field: { onChange, onBlur, value } }) => {
                  return (
                    <Dropdown
                      onBlur={onBlur}
                      height={275}
                      haveOnSelectChange
                      options={organizations}
                      selectedFilters={value}
                      numberDisplayed={0}
                      onSelectChange={(data) => {
                        onChange(data);
                      }}
                    />
                  );
                }}
              />
            </div>
          )}

          {canChangeRole && (
            <div className="admin-users__dropdown">
              <p>Role</p>

              <Controller
                control={control}
                name="role_id"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      height={275}
                      haveOnSelectChange
                      options={orgRoles}
                      selectedFilters={value}
                      numberDisplayed={0}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
          )}
        </div>

        <div className="admin-users__section">
          <div className="switch">
            <p className="switch__title">Assign Role</p>
            <Controller
              control={control}
              name="can_assign_role"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="can_assign_role"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>

          {canAssignRole && (
            <div className="admin-users__dropdown">
              <p>
                {isMultiOrg
                  ? "User can assign any role from user organizations"
                  : "User can assign these roles"}
              </p>
              {!isMultiOrg && (
                <Controller
                  control={control}
                  name="available_for_assign_role_ids"
                  render={({ field: { onChange, value } }) => {
                    return (
                      <Dropdown
                        height={275}
                        haveOnSelectChange
                        options={orgRoles}
                        selectedFilters={value}
                        numberDisplayed={0}
                        onSelectChange={(data) => onChange(data)}
                      />
                    );
                  }}
                />
              )}
            </div>
          )}
          <div className="admin-users__empty" />
        </div>

        <div className="admin-users__section">
          <div className="switch">
            <p className="switch__title">Corporate</p>
            <Controller
              control={control}
              name="corporate"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="corporate"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>

          <div className="switch">
            <p className="switch__title">Reporting Portal</p>
            <Controller
              control={control}
              name="corporate_reporting"
              render={({ field: { onChange, value } }) => {
                return (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="corporate_reporting"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                );
              }}
            />
          </div>

          {isCorporateReporting && !isCorporate && !isMultiOrg ? (
            <div className="admin-users__dropdown">
              <p>Link users to share permissions</p>
              <Controller
                control={control}
                name="user_group_user_ids"
                render={({ field: { onChange, value } }) => {
                  return (
                    <Dropdown
                      includeSelectAll
                      enableOnly
                      height={275}
                      haveOnSelectChange
                      options={linkUsersToSharePermissions}
                      selectedFilters={value}
                      numberDisplayed={0}
                      onSelectChange={(data) => onChange(data)}
                    />
                  );
                }}
              />
            </div>
          ) : (
            <div className="admin-users__empty" />
          )}
        </div>
      </div>
    </>
  );
};
